<template>
  <v-col>
    <v-row class="lg-12">
      <v-col>
        <v-card>
          <v-card-title>
            <v-card-title-text> New Orders</v-card-title-text>
          </v-card-title>
          <v-card-text>
            <p class="text-h5 text--primary">{{ neworderscount }}</p>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="teal accent-4" @click="$router.push('orders')"> View </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col>
        <v-card>
          <v-card-title>
            <v-card-title-text> Completed Orders</v-card-title-text>
          </v-card-title>
          <v-card-text>
            <p class="text-h5 text--primary">{{ completedorderscount }}</p>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="teal accent-4" @click="$router.push('orders')"> View </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col>
        <v-card>
          <v-card-title>
            <v-card-title-text> Canceled Orders</v-card-title-text>
          </v-card-title>
          <v-card-text>
            <p class="text-h5 text--primary">{{ canceledorderscount }}</p>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="teal accent-4" @click="$router.push('orders')"> View </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col sm="12" lg="6">
        <v-card class="mt-15">
          <v-sheet
            class="v-sheet--offset mx-auto"
            color="cyan"
            elevation="12"
            max-width="calc(100% - 32px)"
          >
            <v-sparkline
              :labels="labels"
              :value="value"
              color="white"
              line-width="2"
              padding="16"
            ></v-sparkline>
          </v-sheet>

          <v-card-text class="pt-0">
            <div class="text-h6 font-weight-light mb-2">Oders last 7 days</div>
            <div class="subheading font-weight-light grey--text">
              Last Campaign Performance
            </div>
            <v-divider class="my-2"></v-divider>
            <v-icon class="mr-2" small> mdi-clock </v-icon>
            <span class="text-caption grey--text font-weight-light"
              >last order {{ lastordertime }}</span
            >
          </v-card-text>
        </v-card>
      </v-col>

      <v-col sm="12" lg="6">
        <v-card class="mt-15">
          <v-card-title> Latest Outstandings </v-card-title>
          <v-list two-line class="list-out-container">
            <template v-for="item in items">
              <v-list-item :key="item.CustName">
                <v-list-item-content>
                  <v-list-item-title>{{ item.CustName }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <div class="list-out">
                      <div>
                        <b>Amount : </b> <span>{{ item.Amount }}</span>
                      </div>
                      <div>
                        <b>Paid : </b> <span>{{ item.PaidAmount }}</span>
                      </div>
                      <div>
                        <b>Balance : </b> <span>{{ item.Balance }}</span>
                      </div>
                      <div>
                        <b>Invoice Date : </b>
                        <span>{{ item.InvoiceDate.split("T")[0] }}</span>
                      </div>
                    </div>
                  </v-list-item-subtitle>
                  <v-divider />
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>
<script>

import { HTTP, setAuthToken, BASE_URL } from "../../../lib/http.common";

export default {
  data: () => ({
    neworderscount: 0,
    completedorderscount: 0,
    canceledorderscount: 0,
    lastordertime: "2 days",
    items: [],

    labels: [],
    value: [],
  }),
  methods: {
    getCount() {
      HTTP.get(`${BASE_URL}dashboard/count`)
        .then((response) => {
          //this.neworderscount = response.data.neworderscount;
          let data = response.data[0].dataset[0];
          this.neworderscount = data.pending;
          this.completedorderscount = data.complete;
          this.canceledorderscount = data.canceled;
        })
        .catch((error) => {
          console.log(error);
        });

      HTTP.get(`${BASE_URL}customers/outstanding/top10`)
        .then((response) => {
          this.items = response.data[0].dataset;
        })
        .catch((error) => {
          console.log(error);
        });

      HTTP.get(`${BASE_URL}dashboard/ordcount`)
        .then((response) => {
          this.lastordertime =
            response.data[0].dataset[response.data[0].dataset.length-1].OrderCreateDate.split("T")[0];
          response.data[0].dataset.forEach((row) => {
            let r = row;
            this.labels.push(
              r.OrderCreateDate.split("T")[0].split("-")[1] +
                "-" +
                r.OrderCreateDate.split("T")[0].split("-")[2]
            );
            this.value.push(r.ord_count);
          });
          console.log(this.labels);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  beforeCreate() {
    setAuthToken();
  },

  mounted() {
    this.getCount();
  },
};
</script>
<style>
@media screen and (max-width: 768px) {
  .row {
    flex-direction: column;
  }

  .list-out {
    flex-direction: column;
  }
}
.v-sheet--offset {
  top: -24px;
  position: relative;
}

.list-out {
  display: inline-flex;
}

.list-out > div {
  margin: 3px;
}

.list-out-container {
  overflow: auto;
  max-height: 300px;
}
</style>